import { LOGO_HEIGHT, LOGO_WIDTH } from 'constants/files'

export const getBase64 = (file: Blob) => {
  const reader = new FileReader()

  return new Promise<string>((resolve) => {
    reader.onload = (ev) => {
      if (ev.target) {
        resolve(ev.target.result as string)
      }
    }

    reader.readAsDataURL(file)
  })
}

export const checkImageDimension = (file: File): Promise<boolean> =>
  new Promise((resolve) => {
    const image = new Image()
    image.src = URL.createObjectURL(file)

    image.onload = () => {
      const isValid = image.width === LOGO_WIDTH && image.height === LOGO_HEIGHT
      resolve(isValid)
    }
  })

export const dataURLtoFile = (dataURL: string, filename: string): File => {
  const arr = dataURL.split(',')
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/*'
  const bstr = atob(arr[1])
  const bytes = new Uint8Array(bstr.length)
  for (let i = 0; i < bstr.length; i++) {
    bytes[i] = bstr.charCodeAt(i)
  }
  return new File([bytes], filename, { type: mime })
}
